import { render, staticRenderFns } from "./Header.LanguageSelector.vue?vue&type=template&id=50c1f4d4&scoped=true&"
import script from "./Header.LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./Header.LanguageSelector.vue?vue&type=script&lang=js&"
import style0 from "./Header.LanguageSelector.vue?vue&type=style&index=0&id=50c1f4d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1f4d4",
  null
  
)

export default component.exports